import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import EmptyStateIllustration from '@/components/EmptyStateIllustration'
import CoversByKeyword from '@/modules/covers/CoversByKeyword'
import useJiriHeaderItems from '@/modules/jiri/useJiriHeaderItems'
import { useAppSelector } from '@/redux/store'
import { androidHeaderSearchBarThemeProps } from '@/theme'
import { useTheme } from "expo-router/react-navigation"
import { Stack } from 'expo-router'
import { debounce } from 'lodash-es'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Platform, View } from 'react-native'

export default function SearchPage() {
  const { t } = useTranslation('covers')
  const theme = useTheme()
  const jiriHeaderItems = useJiriHeaderItems()
  const currentUserLoaded = useAppSelector(state => state.currentUser.loaded)
  const [searchKeyword, setSearchKeyword] = useState<string | undefined>(undefined)

  const handleSearchDebounced = useMemo(() => debounce(setSearchKeyword, 500), [setSearchKeyword])

  if (!currentUserLoaded) {
    return null
  }

  return (
    <>
      <Stack.Screen
        options={{
          ...(Platform.OS === 'web' && { headerRightContainerStyle: { paddingRight: 16 } }),
          ...buildScreenHeaderItems({ right: jiriHeaderItems }),
          headerSearchBarOptions: {
            placement: 'automatic',
            placeholder: '搜索表单',
            ...androidHeaderSearchBarThemeProps(theme),
            onChangeText: ({ nativeEvent }) => {
              handleSearchDebounced(nativeEvent.text)
            },
          },
        }}
      />

      {searchKeyword ? (
        <CoversByKeyword keyword={searchKeyword} />
      ) : (
        <View className="items-center justify-center flex-1">
          <EmptyStateIllustration message={t('search.placeholder')} />
        </View>
      )}
    </>
  )
}
